export const aboutMetadata = {
  title: "About Scienza Health - Transforming Memory Care Through AI Innovation",
  description: "Learn how Scienza Health is revolutionizing memory care through AI technology and compassionate support. Discover our mission, technology, and partnerships.",
  structuredData: {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Scienza Health",
    "description": "AI-driven memory care solutions",
    "url": "https://scienzahealth.com/about",
    "sameAs": [
      "https://linkedin.com/company/memorycareai",
      "https://twitter.com/memorycareai"
    ]
  }
};